import Grants from './grants/grant-table-container'
import GrantsHeader from './grants/grants-header'
import FinancialHeaderContainer from "./../grants/financial-header-container"

const reduceGrants = (awarded, project, year) => {
    var result = 0, amount
    project.grants.filter(g => (g.awarded || false) == awarded).map(g => {
        amount = g.years.find(y => y.year == year).amount
        if (amount) {
            result += amount
        }
    })
    return result
}

const reduceFctva = (project, year, ppi) => {
    var result = 0
    if (project.fctva) {
        var fctvaRetrieve
        var toRetrieve = ppi.years.filter(y => {
            // Si pas de valeur contenue dans la colonne, le comportement par défaut est N+1 soit la valeur 1
            fctvaRetrieve = y.fctvaRetrieve == null ? 1 : y.fctvaRetrieve;
            return (fctvaRetrieve + y.year) === year;
        })
        toRetrieve.map(y => {
            if (year = project.years.find(py => py.year == y.year)) {
                result += year.amount * ((ppi.years.find(py => py.year == y.year).fctva || ppi.fctva) / 100)
            }
        })
    }
    return result
}

const amountCellProps = {
    format: "0,0",
    language: "fr-FR",
    type: "numeric",
    mantissa: 0
}

const COSTS = {
    title: 'Coûts',
    readOnly: true,
    type: "normal"
}
const AMOUNT = {
    property: "amount",
    title: 'Montant',
    cellProps: amountCellProps,
    className: "project-amount",
    disabledCells: [2],
    type: "normal"
}
const FUNDING = {
    title: 'Financement',
    className: "grant-funding",
    readOnly: true,
    type: "normal"
}
const AWARDED_GRANTS = {
    title: 'Subventions octroyées',
    readOnly: true,
    type: "awarded",
    func: (project, year) => {
        var result = reduceGrants(true, project, year)
        return (result == 0) ? "" : Math.round(result)
    },
    className: "grant-row",
    cellComponents: [{
        index: 0,
        component: GrantsHeader
    }],
    cellProps: amountCellProps
}
const AWARDED_TABLE = {
    title: "",
    readOnly: true,
    type: "awarded",
    rowComponent: {
        firstCol: 0,
        component: Grants,
    }
}
const INDUCED_CHARGE = {
    title: "charges induites",
    className: 'first-header',
    receipts: true,
    readOnly: true,
    type: "normal"
}

/**
 * Méthode permettant de calculer le total des charges ou des recettes induites
 * @param project
 * @param year - année présente dans le tableau (2022 > 2024)
 * @param isCharge - true si on veut calculer les charges induites, false si on veut calculer les recettes induites
 * @returns {string|number} - le total des charges ou des recettes induites
 */
const calcTotal = (project, year, isCharge) => {
    let file_receties
    if (isCharge) {
        file_receties = project.induceds && project.induceds.filter((itemdata) => !itemdata.induced.receipts)
    } else {
        file_receties = project.induceds && project.induceds.filter((itemdata) => itemdata.induced.receipts)
    }
    let Data_year = file_receties && file_receties.filter(item => item.year <= year)
    let gain = 0
    let loss = 0
    for (let i = 0; i < Data_year.length; i++) {
        gain += Data_year[i].gain ? Data_year[i].gain : 0;
        loss += Data_year[i].loss ? Data_year[i].loss : 0;
    }
    const result = gain - loss
    return result === 0 ? "" : Math.round(result)
}
const Net_INDUCED_CHARGE = {
    title: "TOTAL CHARGES INDUITES",
    func: (project, year, ppi) => {
        return calcTotal(project, year, true)
    },
    className: "cat-footer",
    cellProps: amountCellProps,
    readOnly: true,
    type: "normal"
}
const INDUCED_RECIPE = {
    title: "recettes induites",
    cellProps: amountCellProps,
    className: 'first-header',
    receipts: true,
    readOnly: true,
    type: "normal"
}
const Net_INDUCED_RECIPE = {
    title: "TOTAL RECETTES INDUITES",
    func: (project, year, ppi) => {
        return calcTotal(project, year, false)
    },
    className: "cat-footer",
    cellProps: amountCellProps,
    readOnly: true,
    type: "normal"
}
const ASKED_GRANTS = {
    title: 'Subventions demandées',
    readOnly: true,
    type: "asked",
    func: (project, year) => {
        const result = reduceGrants(false, project, year);
        return (result === 0) ? "" : Math.round(result)
    },
    cellComponents: [{
        index: 0,
        component: GrantsHeader
    }],
    className: "grant-row",
    cellProps: amountCellProps
}
const ASKED_TABLE = {
    title: "",
    readOnly: true,
    type: "asked",
    rowComponent: {
        firstCol: 0,
        component: Grants,
    }
}
const FCTVA = {
    title: "FCTVA",
    func: (project, year, ppi) => {
        var result = reduceFctva(project, year, ppi)
        return result === 0 ? "" : Math.round(result)
    },
    className: "grant-fctva",
    cellProps: amountCellProps,
    readOnly: true,
    type: "normal"
}
const NET_COST = {
    title: "Coût net",
    func: (project, year, ppi) => {
        var projectYear = project.years.find(y => y.year === year);
        if (!projectYear || projectYear.amount <= 0)
            return '';
        var result = projectYear.amount - reduceFctva(project, year, ppi) - reduceGrants(true, project, year) - reduceGrants(false, project, year)
        return result === 0 ? "" : Math.round(result)
    },
    cellProps: amountCellProps,
    readOnly: true,
    type: "normal"
}

const InducedData = (project) => {
    const Receties = []
    var Charge = []
    let file_induites = project.induceds && project.induceds.filter((itemdata) => !itemdata.induced.receipts)
    let file_receties = project.induceds && project.induceds.filter((itemdata) => itemdata.induced.receipts)
    if (file_induites && file_induites.length > 0) {
        file_induites.map((data) => {
            data.gain && data.gain > 0 && Charge.push({
                title: `${data.induced.number} - ${data.induced.label}`,
                func: (project, year) => {
                    const current = data && data.year
                    var result = current <= year && data.gain
                    //const result = data.gain;
                    return result === 0 ? "" : Math.round(result)
                },
                type: "PLUS",
                receipts: false,
                cellComponents: [{
                    index: 0,
                    component: FinancialHeaderContainer
                }],
                cellProps: amountCellProps,
                readOnly: true
            })
            data.loss && data.loss > 0 && Charge.push({
                title: `${data.induced.number} - ${data.induced.label}`,
                func: (project, year) => {
                    const current = data && data.year
                    const result = current <= year && data.loss;
                    return result === 0 ? "" : Math.round(result)
                },
                type: "MOINS",
                receipts: false,
                cellComponents: [{
                    index: 0,
                    component: FinancialHeaderContainer
                }],
                cellProps: amountCellProps,
                readOnly: true
            })
        })
    }
    if (file_receties && file_receties.length > 0) {
        file_receties.map((data) => {
            data.gain && data.gain > 0 && Receties.push({
                title: `${data.induced.number} - ${data.induced.label}`,
                func: (project, year) => {
                    const current = data && data.year
                    const result = current <= year && data.gain;
                    return result === 0 ? "" : Math.round(result)
                },
                type: "PLUS",
                receipts: true,
                cellComponents: [{
                    index: 0,
                    component: FinancialHeaderContainer
                }],
                cellProps: amountCellProps,
                readOnly: true
            })
            data.loss && data.loss > 0 && Receties.push({
                title: `${data.induced.number} - ${data.induced.label}`,
                func: (project, year) => {
                    const current = data && data.year
                    var result = current <= year && data.loss
                    return result === 0 ? "" : Math.round(result)
                },
                type: "MOINS",
                receipts: true,
                cellComponents: [{
                    index: 0,
                    component: FinancialHeaderContainer
                }],
                cellProps: amountCellProps,
                readOnly: true
            })
        })
    }

    return { Charge, Receties }
}

let ROWS = [
    COSTS,
    AMOUNT,
    FUNDING,
    AWARDED_GRANTS,
    AWARDED_TABLE,
    ASKED_GRANTS,
    ASKED_TABLE,
    FCTVA,
    NET_COST,
]
var Rowitem1 = [
    COSTS,
    AMOUNT,
    FUNDING,
    AWARDED_GRANTS,
    AWARDED_TABLE,
    ASKED_GRANTS,
    ASKED_TABLE,
    FCTVA,
    NET_COST,
]
export default (project, theme, subtheme) => {
    let x = InducedData(project)
    return (() => {
        var Rowitem = [...Rowitem1]
        x.Charge.length > 0 && Rowitem.push(INDUCED_CHARGE)
        x.Charge && x.Charge.map((item) => {
            Rowitem.push(item)
        })
        x.Charge.length > 0 && Rowitem.push(Net_INDUCED_CHARGE)
        x.Receties.length > 0 && Rowitem.push(INDUCED_RECIPE)
        x.Receties && x.Receties.map((item) => {
            Rowitem.push(item)
        })
        x.Receties.length > 0 && Rowitem.push(Net_INDUCED_RECIPE)
        var rows = []
        var index = 0
        Rowitem.map(row => {
            //if (project.fctva || (row.title !== FCTVA.title && row.title !== NET_COST.title)) {
            if (project.fctva || row.title !== FCTVA.title) {
                row.index = index
                row.project = project
                row.theme = theme
                row.subtheme = subtheme
                rows.push(row)
                index++
            }
        })

        return {
            COSTS,
            AMOUNT,
            FUNDING,
            AWARDED_GRANTS,
            AWARDED_TABLE,
            ASKED_GRANTS,
            ASKED_TABLE,
            FCTVA,
            NET_COST,
            INDUCED_RECIPE,
            Net_INDUCED_RECIPE,
            INDUCED_CHARGE,
            Net_INDUCED_CHARGE,
            rows: rows
        }
    })()
}



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/investments/project-table-definition.js